import { STATES_OPTIONS_ABBR } from '../../../../common/dropdownConstants';
import { checkClickBuyer } from '../../../../PermissionsWrappers/permissionChecks';
import { type ClickReportVerticalType } from './types';

export const CLICK_REPORT_ALL = '0';
export const CLICK_REPORT_NO_BUYER_SELECTED = '-1';

export const CLICK_REPORT_SITE_OPTIONS = [
  { value: 0, display: 'Select a Vertical' },
  { value: '2', display: 'Auto' },
  { value: '4', display: 'Home' }
];

export const CLICK_REPORT_VERTICALS: Record<string, ClickReportVerticalType> = {
  '2': 'auto',
  '4': 'home'
};

export const isClickReportVertical = (site: unknown) =>
  Object.prototype.hasOwnProperty.call(CLICK_REPORT_VERTICALS, `${site}`);

export const getClickReportVertical = (site: string): ClickReportVerticalType =>
  CLICK_REPORT_VERTICALS[site] ?? 'auto';

export const CLICK_BUYER_AGE_GROUP_OPTIONS = [
  { value: '1', display: 'Under 21' },
  { value: '2', display: '21-24' },
  { value: '3', display: '25-29' },
  { value: '4', display: '30-34' },
  { value: '5', display: '35-39' },
  { value: '6', display: '40-44' },
  { value: '7', display: '45-49' },
  { value: '8', display: '50-54' },
  { value: '9', display: '55-59' },
  { value: '10', display: '60-64' },
  { value: '11', display: '65-69' },
  { value: '12', display: '70-74' },
  { value: '13', display: '75-79' },
  { value: '14', display: '80-84' },
  { value: '15', display: '85-89' },
  { value: '16', display: '90-94' },
  { value: '17', display: 'Over 95' }
];

export const CLICK_REPORT_AGE_GROUP_OPTIONS = [
  { value: CLICK_REPORT_ALL, display: 'All Ages' },
  ...CLICK_BUYER_AGE_GROUP_OPTIONS
];

export const CLICK_REPORT_INSURED_OPTIONS = [
  { value: CLICK_REPORT_ALL, display: 'All' },
  { value: 'yes', display: 'Insured' },
  { value: 'no', display: 'Uninsured' }
];

export const CLICK_REPORT_YES_NO_OPTIONS = [
  { value: CLICK_REPORT_ALL, display: 'All' },
  { value: 'yes', display: 'Yes' },
  { value: 'no', display: 'No' }
];

export const CLICK_REPORT_CREDIT_RATING_ALL = 'all';

export const CLICK_REPORT_CREDIT_RATING_OPTIONS = [
  { value: CLICK_REPORT_CREDIT_RATING_ALL, display: 'All Credit Ratings' },
  { value: 'poor', display: 'Poor' },
  { value: 'average', display: 'Average' },
  { value: 'good', display: 'Good' },
  { value: 'excellent', display: 'Excellent' }
];

export const CLICK_REPORT_HOME_TYPE_OPTIONS = [
  { value: CLICK_REPORT_ALL, display: 'All Home Types' },
  { value: 'single_family_home', display: 'Single Family Home' },
  { value: 'duplex', display: 'Duplex' },
  { value: 'condominium', display: 'Condominium' },
  { value: 'manufactured_home', display: 'Manufactured Home' },
  { value: 'multi_family_home', display: 'Multi Family Home' },
  { value: 'mobile_home', display: 'Mobile Home' },
  { value: 'town_home', display: 'Town Home' },
  { value: 'apartment', display: 'Apartment' }
];

export const CLICK_REPORT_STATE_OPTIONS = STATES_OPTIONS_ABBR.map(
  ({ value, display }) =>
    value === 'all'
      ? { value: CLICK_REPORT_ALL, display: 'All States' }
      : { value, display }
);

export const CLICK_REPORT_AUTO_ONLY_FILTERS = [
  'clickReportMultiCar',
  'clickReportMultiDriver'
];

export const CLICK_REPORT_HOME_ONLY_FILTERS = ['clickReportHomeType'];

export const CLICK_REPORT_ALL_AFFILIATES = 'All Affiliates';

export const CLICK_REPORT_ALL_SOURCES = 'All Sources';

export const getAllAffiliatesLabel = () =>
  checkClickBuyer() ? CLICK_REPORT_ALL_SOURCES : CLICK_REPORT_ALL_AFFILIATES;

export const CLICK_REPORT_MAX_RANGE_DAYS = 31;

export const CLICK_REPORT_MONTHS_BACK = 2;

export const CLICK_REPORT_DATE_NOTE =
  'Note: Max date range is 1 month. Only the current month and two previous months are available.';

export const CLICK_REPORT_RANGE_ERROR =
  'Date range cannot be greater than 1 month. Narrow the range and try again.';
